import React, { useContext } from "react";
import { psychologistTherapyOptions } from "../../Options/psychologistOptions";
import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import {
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
} from "../constructTextFromValues";
import therapiesSuggestedIcon from "../../../../assets/doctorIcons/therapiesSuggested.svg";
import { checkEmpty } from "../../../../helpers/utility";

const PsychologistTherapySummary = ({ context }) => {
  const { formData } = useContext(context);
  const constructTherapySummaryItems = () => {
    const therapySummaryItems = [];
    if (checkEmpty(formData?.therapies_suggested)) {
      therapySummaryItems.push({
        key: "1",
        label: "Therapy",
        children: (
          <>
            {getLabelTagsWithDescription(
              psychologistTherapyOptions,
              formData?.therapies_suggested
            )}
            {getLabelTagsWithDynamicInputs(
              formData?.therapies_suggested?.others
            )}
          </>
        ),
      });
    }
    return therapySummaryItems;
  };
  const therapySummaryItems = constructTherapySummaryItems();
  return (
    <SummaryWrapper
      items={therapySummaryItems}
      title={
        <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
          <Space>
            <Image src={therapiesSuggestedIcon} width={18} preview={false} />
            <span style={{ fontSize: "16px", fontWeight: "normal" }}>
              Therapies Suggested
            </span>
          </Space>
        </span>
      }
    />
  );
};

export default PsychologistTherapySummary;
